import React from 'react';
import { Box, Typography } from '@mui/material';
import { colors } from '../../../theme';
import { BenefitBullet as BenefitBulletType } from '../types/landing';

interface BenefitBulletProps {
  bullet: BenefitBulletType;
}

export const BenefitBullet: React.FC<BenefitBulletProps> = ({ bullet }) => {
  const IconComponent = bullet.icon;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        color: colors.slate[200],
      }}
    >
      <Box sx={{ color: colors.signalOrange, display: 'flex', alignItems: 'center' }}>
        <IconComponent />
      </Box>
      <Typography sx={{ fontSize: '0.875rem', fontWeight: 500, lineHeight: 1 }}>
        {bullet.text}
      </Typography>
    </Box>
  );
};
